import firebase from 'firebase/app'

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
// import "firebase/analytics";

// Add the Firebase products that you want to use
import 'firebase/auth'
import 'firebase/firestore'

// Your web app's Firebase configuration
import config from './config'

if (process.env.NODE_ENV !== 'production') {
  firebase.initializeApp(config.firebaseConfig)
} else {
  firebase.analytics()
}
const firestore = firebase.firestore()
const auth = firebase.auth()

firebase.auth().useDeviceLanguage()

const { Timestamp, GeoPoint } = firebase.firestore

export default firebase
export { auth, firestore, Timestamp, GeoPoint }
